module.exports = __webpack_public_path__ + "static/img/1.d17f5c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/image/07/1.png
// module id = SJ7Y
// module chunks = 2